export const GOFUNDME_USER_JOURNEYS_VARIANTS = [
  'supporters',
  'tools',
  'supporters_b',
  'tools_b',
  'goodstack_supporters',
  'goodstack_tools'
] as const

export type GofundmeUserJourneysVariant = typeof GOFUNDME_USER_JOURNEYS_VARIANTS[number]

// `control` is deliberately absent: those users see no GFM content, so they are treated as
// having no variant rather than as a third case every touchpoint has to handle.
export const isGofundmeUserJourneysVariant = (value: unknown): value is GofundmeUserJourneysVariant =>
  (GOFUNDME_USER_JOURNEYS_VARIANTS as readonly unknown[]).includes(value)
